<template>
  <div>
    <transition name="vue-table-loader">
      <div class="vue-details-loader alt" v-if="loading">
        <span class="fa fa-cog fa-spin fa-1x"></span>
      </div>
    </transition>
    <transition name="fade">
      <div>
        <vuetable
          ref="vuetable"
          :fields="fields"
          :api-url="apiURL"
          :css="css.table"
          :per-page="perPage"
          :append-params="moreParams"
          noDataTemplate="No Items to Sync"
          pagination-path=""
          @vuetable:pagination-data="onPaginationData"
          @vuetable:loaded="onLoaded"
          @vuetable:loading="onLoading"
        ></vuetable>
        <div class="row mt-1">
          <div class="col-md-6">
            <base-pagination-info :css="css.table" ref="paginationInfo">
            </base-pagination-info>
          </div>
          <div class="col-md-6">
            <base-pagination
              ref="pagination"
              @vuetable-pagination:change-page="onChangePage"
            ></base-pagination>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import BasePagination from "../../tables/base-pagination.vue";
import BasePaginationInfo from "../../tables/base-pagination-info.vue";

const base_url = window.location.protocol + "//" + window.location.host;

export default {
  name: "generic-sync-v2-table",
  components: {
    "base-pagination": BasePagination,
    "base-pagination-info": BasePaginationInfo,
  },
  props: {
    paginate: {
      required: true,
      type: Number,
    },
    channelId: {
      required: true,
      type: Number,
    }
  },
  mounted() {
    this.$root.$on('refresh-sync-table', () => {
      this.$refs.vuetable.refresh();
    });
  },
  data() {
    return {
      apiURL: `${base_url}/channels/${this.channelId}/sync_queue`,
      perPage: this.paginate,
      loading: true,
      uiStates: {
        errorMessage: null,
        showLoading: true,
      },
      moreParams: {},
      fields: [
        {
          name: "entity_id",
          title: "Entity ID",
        },
        {
          name: "entity_type_readable",
          title: "Entity",
        },
        {
          name: "event_type_readable",
          title: "Sync type",
        },
        {
          name: "priority",
          title: "Priority",
        },
        {
          name: "event_source",
          title: "Source",
        },
        {
          name: "created_at",
          title: "Created",
        },
        {
          name: "updated_at",
          title: "Updated",
        },
      ],
      css: {
        table: {
          tableClass: "table table-middle table-minimal",
          tableWrapper: "",
          ascendingIcon: "sort-icon-asc",
          descendingIcon: "sort-icon-desc",
          infoClass: "",
        },
      },
    };
  },
  watch: {
    paginate: function (value) {
      this.perPage = value;

      this.$nextTick(() => this.$refs.vuetable.refresh());
    },
  },
  methods: {
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onLoading: function() {
      this.loading = true;
    },
    onLoaded: function () {
      this.loading = false;
    },
  },
};
</script>